/**
 * Returns an estimate of reading time for a given set of content
 * @param content The string content to calculate reading time for
 */
const getReadingTime = (content: string, language: string): string => {
  if (language === 'ja') {
    const characterCount = content.split('').length;

    return Math.round(characterCount / 600).toString();
  }

  const wordCount = content.split(/\s/g).length;
  const readingMinutes = Math.round(wordCount / 200);

  return readingMinutes.toString();
};

export default getReadingTime;
